<template>
  <div class="modal_box box_style">
    <p class="title">视频监控</p>
    <div class="video_box">
      <video-streaming :url="curVideoSrc" v-if="1 == 2" />
      <div id="xgFlv" class="xg_flv"></div>
    </div>
    <div class="btn_close" @click="closeVideo"><img src="@/assets/hs/icon_close.png" alt="" /></div>
  </div>
</template>

<script>
import VideoStreaming from '@/components/Streaming/index.vue';
import Player from 'xgplayer';
import FlvPlugin from 'xgplayer-flv';
import 'xgplayer/dist/index.min.css';
import { BASE_IP_URL } from '@/globalConfig';
export default {
  name: 'modalVideo',
  components: {
    VideoStreaming,
  },
  props: {
    videoSrc: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      curVideoSrc: '',
      curVideoList: [],
    };
  },
  watch: {
    videoSrc: {
      handler: function (newV, oldV) {
        if (newV) {
          this.curVideoSrc = newV;
        } else {
          this.curVideoSrc = oldV;
        }
        console.log('this.curVideoSrc :>>oldV ', this.curVideoSrc, newV, oldV);
      },
      immediate: true,
    },
  },
  mounted() {
    this.curVideoList = this.$Storage.get('videoListStorage') || null;
    const that = this;
    var player = new Player({
      id: 'xgFlv',
      // el: videoEl[i],
      url: that.curVideoSrc.replace(
        'http://223.214.6.181:8950/openUrl/',
        // '172.30.100.204:8950'
        BASE_IP_URL
      ),
      playsinline: true,
      poster: 'http://172.30.100.201/subapp/huoshan-gis-platform/static/img/2.20ed85c7.jpg',
      autoplay: true,
      width: 800,
      height: 443,
      plugins: [FlvPlugin],
      isLive: true,
    });
  },
  methods: {
    closeVideo() {
      this.$bus.$emit('showVideoModal', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_box {
  width: 866px;
  height: 543px;
  background: #09325f;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  .title {
    font-size: 20px;
    text-align: center;
    margin-top: 15px;
  }
  .video_box {
    width: 800px;
    height: 443px;
    margin: 0 auto;
    margin-top: 23px;
  }
  .btn_close {
    width: 36px;
    height: 36px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
}
</style>
